import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip } from '@weezevent/nacre';
import { ReactComponent as Seat } from '@weezevent/throne/dist/images/seating/siege-available.svg';

import Styles from '../../../styles/rate/rateCategorySeat.module.css';

export function RateCategorySeat({ rate, categories, event = null }) {
    const category = React.useMemo(() => {
        return categories?.find(category => category.uuid && category.uuid === (rate.category || rate.rate_template?.category));
    }, [rate, categories]);

    if (!category || !event?.isFakeSeatingMultipleCategories(categories)) {
        return null;
    }

    return (
        <>
            <style>{`
                    svg.seat-category {
                        width: 18px;
                        height: 17px;
                        margin-right: 3px;
                   }

                    svg.seat-category-${category.color.substring(1, category.color.length)} path {
                        fill: ${category.color};
                   }
                `}</style>
            <Tooltip triggerOnHover={true} title={category.name} className={Styles['tooltip-rateList-category']}>
                <Seat className={`seat-category ${'seat-category-' + category.color.substring(1, category.color.length)}`} />
            </Tooltip>
        </>
    );
}

RateCategorySeat.propTypes = {
    rate: PropTypes.object,
    categories: PropTypes.array
};
